import { CognitoUserPool } from "amazon-cognito-identity-js";

// PARAS
const poolData = {
  UserPoolId: "us-east-1_dITy6qvSL",
  ClientId: "6bektvg0nm0q6p8n4ugj02nd4a",
};

export default new CognitoUserPool(poolData);
